<div class="prompt-text">{{ promptText_() }}</div>
<div #chatOptionsContainer class="chat-options">
  @for (option of chatOptions_(); track option.id) {
    <div 
      #chatOption 
      class="chat-option" 
      [id]="'chat-option-' + option.id"
    >
      {{ option.name }}
    </div>
  }
</div>
<ods-button 
  class="next-btn" 
  (click)="goToNextStep()" 
  [disabled]="!isSelectionMade_()"
>
  Next
</ods-button>
  